import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import HtmlHeader from "@template/components/HtmlHeader";
import Breadcrumbs from "@template/components/Breadcrumbs";
import Footer from "@template/components/Footer";
import WelcomeMessage from "@template/components/WelcomeMessage";
import InfoBanner from "@template/components/InfoBanner/InfoBannerControl";
import SidePanel from "@template/components/Navigation/SidePanel";
import CountrySelector from "@template/components/CountrySelector";
import SecuredTouch from "@template/components/Footer/SecuredTouch";
import SecureScriptContainer from "@template/components/Footer/SecureScriptContainer";
import SignalScriptLoader from "@template/components/Footer/SignalScriptLoader";

import { isMainAppHidden } from "@template/state/modules/layout/selectors";

const MainContentComponent = ({ isMainAppHidden, webContext }) => (
  <div
    aria-hidden={isMainAppHidden ? true : null}
    className="chrome-main-content--accessible"
  >
    <div id="chrome-header">
      <HtmlHeader />
    </div>
    <div id="chrome-breadcrumb">
      <Breadcrumbs />
    </div>
    <main
      id="chrome-app-container"
      dangerouslySetInnerHTML={{ __html: "<!--%applicationContent%-->" }}
    ></main>
    <div id="chrome-footer">
      <Footer />
      <SecuredTouch />
      <SecureScriptContainer webContext={webContext} />
      <SignalScriptLoader />
    </div>
    <div id="chrome-welcome-mat">
      <WelcomeMessage />
    </div>
    <div id="chrome-info-banner">
      <InfoBanner />
    </div>
  </div>
);

const ModalContentComponent = ({ isMainAppHidden }) => (
  <div id="chrome-modal-container" aria-hidden={!isMainAppHidden ? true : null}>
    <SidePanel />
    <CountrySelector />
  </div>
);

ModalContentComponent.propTypes = {
  isMainAppHidden: PropTypes.bool
};

MainContentComponent.propTypes = {
  isMainAppHidden: PropTypes.bool,
  webContext: PropTypes.object
};

const mapStateToProps = state => ({
  isMainAppHidden: isMainAppHidden(state)
});
export const ModalContent = connect(mapStateToProps)(ModalContentComponent);
export const MainContent = connect(mapStateToProps)(MainContentComponent);
